import { db } from "@/main";

export default {
    state: {
      list: [],
      unsuscribe: null,
    },
    mutations: {
      ADD_REMINDER(state, reminder) {
        state.list.push(reminder)
      },
      UPDATE_REMINDER(state, reminder) {
        let index = state.list.findIndex(
          obj => obj.id == reminder.id
        );
        state.list.splice(index, 1, reminder);
      },
      DELETE_REMINDER(state, reminder ) {
        let index = state.list.findIndex(
          obj => obj.id == reminder.id
        );
        state.list.splice(index, 1);
      },
      CLEAR_REMINDERS(state) {
        state.list = []
      }
    },
    actions: {
      getReminders( { state, rootState, commit } ) {

          if( state.list.length > 0 ) {
            return new Promise( (resolve, reject) => { resolve() })
          }

          return new Promise((resolve, reject) => {
              
              // Current date
              const now = new Date()
              now.setHours(0,0,0,0)

              state.unsuscribe = db.collection("reminders").onSnapshot(snap => {
                  
                  snap.docChanges().forEach(change => {
                    const reminder = change.doc.data()
                    reminder.id = change.doc.id
    
                    // Add date_class="expired" when programmed date is previus of now
                    reminder.date_class = ''
                    reminder.date_text = reminder.date.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3/$2/$1');
                    const newReminderDate = new Date(reminder.date+"T00:00:00")
                    
                    if( newReminderDate < now )                         
                      reminder.date_class = 'expired'
                    
                    let trash = rootState.orders.options.find(element => element.value == reminder.trash_type)
                      reminder.trash_type_t = trash ? trash.label : 'Otros' // ej. Aceite

                    if (change.type === "added") { 
                        let orderReminder = state.list.find( e => e.id === reminder.id )
                        if( !orderReminder )                                              
                          commit('ADD_REMINDER', reminder)
                    }
                    else if (change.type === "modified") {
                        commit('ADD_REMINDER', reminder)
                    }
                    else if (change.type === "removed") {
                        commit( 'DELETE_REMINDER', reminder )
                    }
                  });
                  resolve()
              }, function(error) {
                  commit('SET_ERROR', { section: 'Reminders', function: 'getReminders', msg: error });
                  reject()
              });
          })
          
      },
      addReminder( { commit }, reminder ) {
        delete reminder.date_class
        delete reminder.date_text

        return new Promise((resolve, reject) => {
          db.collection("reminders").doc(reminder.client_id+'_'+reminder.trash_type)
          .set(reminder)
          .then(function(docRef) {
            //reminder.id = docRef.id;
            //commit( 'ADD_REMINDER', reminder )
            resolve()
          })
          .catch(function(error) {
            commit('SET_ERROR', { section: 'Reminders', function: 'addReminder', msg: error });
            reject()
          })
        })
      },
      deleteReminder( { commit }, reminder ) {
        return new Promise((resolve, reject) => {
          db.collection("reminders")
          .doc(reminder.id)
          .delete()
          .then(function() {
            //commit( 'DELETE_REMINDER', reminder )
            resolve()
          })
          .catch(function(error) {
            commit('SET_ERROR', { section: 'Reminders', function: 'deleteReminder', msg: error });
            reject()
          });
        })
      },
      unsuscribeReminder( { state } ) {
        if( state.unsuscribe )
          return state.unsuscribe()
        return true
      }
    }
}
  